import {
  DashboardSquare02Icon,
  TemplateIcon,
  CategoryIcon,
  ProductIcon,
  MarketAreaIcon,
  BlogIcon,
  GalleryIcon,
  TestimonialIcon,
  PartnerIcon,
  InquiryIcon,
  TeamIcon,
  OrganizationIcon,
  BusinessTypeIcon,
  OrganizationTypeIcon,
  LegalFirmIcon,
  CountryIcon,
  StateIcon,
  CityIcon,
  // SettingIcon,
  CompanyIcon,
  DomainIcon,
  SocialLinkIcon,
  LogoIcon,
  AnalyticsIcon,
  PlanIcon,
  ArrowRight02Icon2,
  GalleryImageIcon,
  GalleryCategoryIcon,
  GalleryVideoIcon,
  FaqIcon,
  ColorThemeIcon,
  // HomeIcon,
  // AboutUsIcon,
  // PrivacyPolicyIcon,
  // TermsAndConditionsIcon,
  // SEOContentIcon
} from "../../assets/icons";

export const SidebarContent = [
  {
    title: "Dashboard",
    icon: (
      <DashboardSquare02Icon
        width={18}
        height={18}
        color="#444050"
        strokeWidth="2"
      />
    ),
    link: "/",
  },
  {
    title: "Organizations",
    icon: (
      <OrganizationIcon
        width={18}
        height={18}
        color="#444050"
        strokeWidth="2"
      />
    ),
    link: "/organizations",
  },
  {
    title: "Templates",
    icon: (
      <TemplateIcon width={18} height={18} color="#444050" strokeWidth="2" />
    ),
    link: "/templates",
  },
];

export const ThemeConfigurationContent = [
  {
    title: "Color Configuration",
    icon: (
      <ColorThemeIcon
        width={18}
        height={18}
        color="#444050"
        strokeWidth="2"
      />
    ),
    link: "/color-configuration",
  },
];

export const getOrganizationThemeConfigurationContent = (selectedOrganizationId) => {
  return [
    {
      title: "Color Configuration",
      icon: (
        <ColorThemeIcon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}/color-configuration`,
    },
  ];
};
export const ConfigurationContent = [
  {
    title: "Business Types",
    icon: (
      <BusinessTypeIcon
        width={18}
        height={18}
        color="#444050"
        strokeWidth="2"
      />
    ),
    link: "/business-types",
  },
  {
    title: "Organization Types",
    icon: (
      <OrganizationTypeIcon
        width={18}
        height={18}
        color="#444050"
        strokeWidth="2"
      />
    ),
    link: "/organization-types",
  },
  {
    title: "Legal Firms",
    icon: (
      <LegalFirmIcon width={18} height={18} color="#444050" strokeWidth="2" />
    ),
    link: "/legal-firms",
  },
  {
    title: "Countries",
    icon: (
      <CountryIcon width={18} height={18} color="#444050" strokeWidth="2" />
    ),
    link: "/countries",
  },
  {
    title: "States",
    icon: <StateIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    link: "/states",
  },
  {
    title: "Cities",
    icon: <CityIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    link: "/cities",
  },
];

export const getOrganizationSideBarContent = (
  selectedOrganizationId,
  selectedOrganizationType
) => {
  return [
    {
      title: "Dashboard",
      icon: (
        <DashboardSquare02Icon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}`,
    },
    {
      title: "Categories",
      icon: (
        <CategoryIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: `/organization/${selectedOrganizationId}/categories`,
    },
    ...(selectedOrganizationType === "Product" ||
    selectedOrganizationType === "Product/Service"
      ? [
          {
            title: "Products",
            icon: (
              <ProductIcon
                width={18}
                height={18}
                color="#444050"
                strokeWidth="2"
              />
            ),
            link: `/organization/${selectedOrganizationId}/products`,
          },
        ]
      : []),
    {
      title: "Blogs",
      icon: <BlogIcon width={18} height={18} color="#444050" strokeWidth="2" />,
      link: `/organization/${selectedOrganizationId}/blogs`,
    },
    {
      title: "Gallery",
      icon: (
        <GalleryIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      dropdownIcon: (
        <ArrowRight02Icon2
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ), // Optional if needed
      link: `/organization/${selectedOrganizationId}/galleries`, // Optional for fallback
      children: getOrganizationGalleryContent(selectedOrganizationId), // ✅ Sub-items here
    },
    {
      title: "Testimonials",
      icon: (
        <TestimonialIcon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}/testimonials`,
    },
    {
      title: "Clients",
      icon: (
        <PartnerIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: `/organization/${selectedOrganizationId}/clients`,
    },
    {
      title: "Inquiries",
      icon: (
        <InquiryIcon width={24} height={24} color="#444050" strokeWidth="1.5" />
      ),
      link: `/organization/${selectedOrganizationId}/inquiries`,
    },
    {
      title: "Target Regions",
      icon: (
        <MarketAreaIcon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}/target-regions`,
    },
    {
      title: "Teams",
      icon: <TeamIcon width={18} height={18} color="#444050" strokeWidth="2" />,
      link: `/organization/${selectedOrganizationId}/teams`,
    },
    {
      title: "Page",
      icon: (
        <GalleryIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: `/organization/${selectedOrganizationId}/pages`,
    },
    {
      title: "FAQs",
      icon: <FaqIcon width={18} height={18} color="#444050" strokeWidth="2" />,
      link: `/organization/${selectedOrganizationId}/faqs`,
    },
    // {
    //     title: "Settings",
    //     icon: <SettingIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    //     link: `/organization/${selectedOrganizationId}/settings`,
    // },
  ];
};

export const getOrganizationGalleryContent = (selectedOrganizationId) => {
  return [
    {
      title: "Category",
      icon: (
        <GalleryCategoryIcon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}/gallery-categories`,
    },
    {
      title: "Image",
      icon: (
        <GalleryImageIcon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}/gallery-images`,
    },
    {
      title: "Video",
      icon: (
        <GalleryVideoIcon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}/gallery-videos`,
    },
  ];
};

export const getOrganizationConfigurationContent = (selectedOrganizationId) => {
  return [
    // {
    //     title: "General",
    //     icon: <SettingIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    //     link: `/organization/${selectedOrganizationId}/general`,
    // },
    {
      title: "Company Details",
      icon: (
        <CompanyIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: `/organization/${selectedOrganizationId}/company-details`,
    },
    {
      title: "Domain",
      icon: (
        <DomainIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: `/organization/${selectedOrganizationId}/domain`,
    },
    {
      title: "Social Links",
      icon: (
        <SocialLinkIcon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}/social-links`,
    },
    {
      title: "Logo",
      icon: <LogoIcon width={18} height={18} color="#444050" strokeWidth="2" />,
      link: `/organization/${selectedOrganizationId}/logo`,
    },
    {
      title: "Google Analytics",
      icon: (
        <AnalyticsIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: `/organization/${selectedOrganizationId}/google-analytics`,
    },
    {
      title: "Plan Configuration",
      icon: <PlanIcon width={18} height={18} color="#444050" strokeWidth="2" />,
      link: `/organization/${selectedOrganizationId}/plan-configuration`,
    },
    // {
    //     title: "Home",
    //     icon: <HomeIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    //     link: `/organization/${selectedOrganizationId}/home-page`,
    // },
    // {
    //     title: "About Us",
    //     icon: <AboutUsIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    //     link: `/organization/${selectedOrganizationId}/about-us`,
    // },
    // {
    //     title: "Privacy Policy",
    //     icon: <PrivacyPolicyIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    //     link: `/organization/${selectedOrganizationId}/privacy-policy`,
    // },
    // {
    //     title: "Terms & Conditions",
    //     icon: <TermsAndConditionsIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    //     link: `/organization/${selectedOrganizationId}/terms-conditions`,
    // },
    // {
    //     title: "SEO Configuration",
    //     icon: <SEOContentIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    //     link: `/organization/${selectedOrganizationId}/seo-configuration`,
    // },
  ];
};
